/**============================================================
*   [contactform7]
*   description : contactform7のカスタマイズ処理を記述
============================================================*/
(function ($) {
  document.addEventListener('wpcf7submit', function (event) {
    //確認画面で非選択のチェックボックスとラジオボタンを非表示
    switch (event.detail.status) {
      case 'wpcf7c_confirmed':
        $('.wpcf7-form input[type=checkbox]').each(function () {
          if ($(this).prop('checked') === false) {
            $(this).closest('.wpcf7-list-item').hide()
          } else {
            $(this).hide()
          }
        })
        $('.wpcf7-form input[type=radio]').each(function () {
          if ($(this).prop('checked') === false) {
            $(this).closest('.wpcf7-list-item').hide()
          } else {
            $(this).hide()
          }
        })
        break
    }
  }, false)

  // 戻るボタンで戻った場合に再度表示させる.
  $('.wpcf7-back').on('click', function () {
    $('.wpcf7-form input[type=checkbox]').each(function () {
      var parent = $(this).closest('.wpcf7-list-item')
      parent.show()
      $(this).show()
    })

    $('.wpcf7-form input[type=radio]').each(function () {
      var parent = $(this).closest('.wpcf7-list-item')
      parent.show()
      $(this).show()
    })

    $('form').removeClass('custom-wpcf7c-confirmed')
  })

  //画像アップロードのスタイルカスタマイズ
  $('#productImage').change(function() {
    var val = $(this).val();
    var path = val.replace(/\\/g, '/');
    var match = path.lastIndexOf('/');
    $('#productImageTxt').css("display","inline-block");
    $('#productImageTxt').val(match !== -1 ? val.substring(match + 1) : val);
  });
  $('#productImageTxt').bind('keyup, keydown, keypress', function() {
    return false;
  });
  $('#btn').on('click',function() {
    $('#productImage').trigger('click');
  });

  //確認用アドレスコピペ禁止
  $('#your-email_confirm').on('copy cut paste',function(e){
    e.preventDefault();
});
})(window.jQuery)
